// extracted by mini-css-extract-plugin
export var contentWrapper = "index-module--content-wrapper--8fbde";
export var heading = "index-module--heading--be982";
export var hero = "index-module--hero--76e1b";
export var image = "index-module--image--651ef";
export var overlay = "index-module--overlay--1afaf";
export var shortHero = "index-module--shortHero--46e5d";
export var title = "index-module--title--32a19";